module.exports = __webpack_public_path__ + "img/ship.2c431b22.svg";